import { data } from '../../svg/MoveIn/data';
import { makeIcon } from '../makeIcon';

export const MoveIn = makeIcon(data, 'move_in', 'MoveIn');

export default MoveIn;
